<template>
  <div class="item-cont">
    <div class="item-header">
      <div class="header-title">
        {{title}}
        <div v-if="titleImgClassIndex==0" class="img img-0"></div>
        <div v-if="titleImgClassIndex==1" class="img img-1"></div>
        <div v-if="titleImgClassIndex==2" class="img img-2"></div>
        <div v-if="titleImgClassIndex==3" class="img img-3"></div>
      </div>
    </div>
    <div class="item-list-cont">
      <a class="item-unit" v-for="(item,index) in firstList" :key="index" :href="item.qyUrl">
        <div class="unit-top">
          <div class="unit-top-1">
            <div class="unit-img">
              <img :src="item.logoPath ? item.logoPath : '' " alt />
            </div>
            <div class="unit-r">
              <div class="unit-r-t1">{{item.name}}</div>
              <div class="unit-r-t2">
                <p>行业：{{item.industry}}</p>
                <p>规模：{{item.scale}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unit-m clearfix">
          <div
            v-if="item.welfare && subitem"
            v-for="(subitem,index) in item.welfare.split(',')"
          >{{subitem}}</div>
        </div>
        <a class="unit-bottom">
          <span>全部职位</span>
        </a>
      </a>
    </div>
    <div class="btn-more" @click="loadMore" v-show="showBtn">
      <p>查看更多职位>></p>
    </div>
  </div>
</template>

<script>
const random = parseInt(Math.random() * 10);
console.log(random);
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    itemList: {
      type: Array,
      default: function(argument) {
        return [];
      }
    }
  },
  data() {
    return {
      firstList: [],
      showBtn: true,
      titleImgClassIndex:
        random <= 3 ? random : random - 3 <= 3 ? random - 3 : 0
    };
  },
  mounted() {
    this.firstList = this.itemList.slice(0, 6);
    this.firstList.length < 6 && (this.showBtn = false);
  },
  methods: {
    loadMore() {
      this.firstList = this.itemList;
      this.showBtn = false;
    }
  }
};
</script>
<style lang="less" scoped>
.item-cont {
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  margin-top: 0.6rem;
  width: 100%;
  box-sizing: border-box;
  .item-header {
    position: relative;
    text-align: center;
    margin-bottom: 0.8rem;
    .header-title {
      display: inline-block;
      font-size: 0.493333rem;
      // text-shadow: -2px -2px 2px #601ff2, 2px -2px 2px #601ff2, -2px 2px 2px #601ff2, 2px 2px 2px #601ff2;
      font-weight: 500;
      color: #121e5b;
      position: relative;
      margin: 0 auto;
      padding: 0 1.2rem;
      > .img {
        position: absolute;
        bottom: 0;
        top: 10px;
        margin: auto;
        width: 0.5rem;
        height: 1rem;
      }
      .img-0 {
        background: url("//pic1.58cdn.com.cn/nowater/jltx/n_v249519832878349878bb814fdb54e476b.png")
          no-repeat;
        background-size: contain;
        right: 0.5rem;
      }
      .img-1 {
        background: url("//pic1.58cdn.com.cn/nowater/jltx/n_v2ce176878a3d84ac5ba35eb58177bfb13.png")
          no-repeat;
        background-size: contain;
        right: 0.5rem;
      }
      .img-2 {
        width: 0.6rem;
        background: url("//pic1.58cdn.com.cn/nowater/jltx/n_v2f6ad7394126f423fa98d24fedbe7d78f.png")
          no-repeat;
        background-size: contain;
        left: 0.4rem;
      }
      .img-3 {
        background: url("//pic1.58cdn.com.cn/nowater/jltx/n_v2b497bd599cf347959e5963dba7765c8b.png")
          no-repeat;
        background-size: contain;
        left: 0.5rem;
      }
    }
  }
  .item-list-cont {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: #444444;
    .item-unit {
      // flex: 1;
      width: 4.666666rem;
      border-radius: 3px;
      background: #fff;
      margin-bottom: 0.213333rem;
      position: relative;
      overflow: hidden;
    }
  }
}
.unit-top {
  color: #444444;
  padding: 0.333333rem 0 0.293333rem 0.333333rem;
  box-sizing: border-box;
  .unit-top-1 {
    display: flex;
    .unit-img {
      width: 1.133333rem;
      height: 1.133333rem;
      border: 1px solid #d6d6d6;
      box-sizing: border-box;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .unit-r {
      padding-left: 0.12rem;
      flex: 1;
      .unit-r-t1 {
        font-size: 0.373333rem;
        line-height: 1em;
        padding-top: 0.026667rem;
        padding-bottom: 0.2rem;
        width: 100%;
        max-width: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .unit-r-t2 {
        p {
          line-height: 1.2em;
          font-size: 0.213333rem;
        }
      }
    }
  }
}
.unit-m {
  width: 100%;
  padding-left: 0.2rem;
  // padding-right: 0.2rem;
  font-size: 0.226667rem;
  // display: flex;
  // flex-wrap: nowrap;
  box-sizing: border-box;
  // justify-content: space-between;
  margin-bottom: 0.4rem;
  > div {
    float: left;
    color: #512c0b;
    line-height: 1em;
    background: linear-gradient(to right, #ffb2ac, #ffb2ac);
    border-radius: 0.266667rem;
    padding: 0.093333rem 0.2rem;
    margin-top: 0.1rem;
    overflow-x: hidden;
    margin-right: 0.133333rem;
  }
}
.unit-bottom {
  display: inline-block;
  // background: #fec50a;
  background: #367076;
  // color: #24099b;
  color: #fff;
  width: 100%;
  text-align: center;
  line-height: 0.866667rem;
  // position: absolute;
  // bottom: 0px;
  span {
    position: relative;
    font-size: 0.293333rem;
  }
  span:after {
    display: inline-block;
    content: " ";
    background-image: url(../assets/img/arrow-r.png);
    background-size: contain;
    background-repeat: no-repeat;
    width: 0.293333rem;
    height: 0.293333rem;
    position: absolute;
    top: 0.08rem;
    margin-left: 0.066667rem;
  }
}

// btn
.btn-more {
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  padding-bottom: 2rem;
  width: 100%;
  box-sizing: border-box;
  p {
    // background:#04d6e9;
    // background: #fe5122;
    background: #367076;
    border-radius: 50px;
    font-size: 0.426667rem;
    // color: #24099b;
    color: #fff;
    text-align: center;
    line-height: 1.066667rem;
    margin-top: 0.666667rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/baseList.vue